import path from 'path'

export function getOgImageURL(filename: string, lang = 'en') {
    return process.env.NEXT_PUBLIC_BASE_URL + path.join('/static/ogimages/', lang, filename)
}
